import { configureStore } from '@reduxjs/toolkit';

import appReducer from 'src/store/app';
import authReducer from 'src/store/auth';
import newsReducer from 'src/store/news';
import exchangesReducer from 'src/store/exchanges';
import ordersReducer from 'src/store/orders';
import profileReducer from 'src/store/profile';
import reviewsReducer from 'src/store/reviews';

import adminsReducer from 'src/store/admins';
import adminAuthReducer from 'src/store/adminAuth';
import adminCurrencyReducer from 'src/store/adminCurrency';
import adminExchangesReducer from 'src/store/adminExchanges';
import adminReviews from 'src/store/adminReviews';
import adminOrderReducer from 'src/store/adminOrders';
import adminUsersReducer from 'src/store/adminUsers';
import adminCashExchange from 'src/store/adminCashExchange';

export const rootStore = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    news: newsReducer,
    exchanges: exchangesReducer,
    orders: ordersReducer,
    profile: profileReducer,
    reviews: reviewsReducer,

    admins: adminsReducer,
    adminAuth: adminAuthReducer,
    adminCurrency: adminCurrencyReducer,
    adminExchanges: adminExchangesReducer,
    adminReviews: adminReviews,
    adminOrders: adminOrderReducer,
    adminUsers: adminUsersReducer,
    adminCashExchange: adminCashExchange,
  },
});
